// extracted by mini-css-extract-plugin
module.exports = {"container":"toggleFavoriteButton__container___2zs2v","icon":"toggleFavoriteButton__icon___1_2mm","is-active":"toggleFavoriteButton__is-active___2LC3h"};